export default {"src":"/_next/static/media/spotify-podcast-badge-blk-grn.3aee33c1.svg","height":40,"width":165,"blurWidth":0,"blurHeight":0};